import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { TermsAndConditionsService } from 'src/app/pages/terms-and-conditions/terms-and-conditions.service';
import { TermsandConditions } from 'src/app/pages/terms-and-conditions/terms-and-conditions.model';
import { ContactUsService } from '../contact-us/contact-us.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss']
})
export class TermsAndConditionsComponent implements OnInit {
  isUserLoggedIn: boolean;
  showWelcomePage: boolean;
  termCheck: boolean = false;
  isTermCheckSubmit: boolean = false;
  userId: any = null;
  termsAndConditionId:string;
  termsAndCondition:TermsandConditions;
    isFromFooter: boolean;
  isTermsandConditionsAvailable: boolean;
  Id: any = null;
  
  constructor(private router: Router,
    private route: ActivatedRoute, private dataService: TermsAndConditionsService,
    private contactUsService: ContactUsService, private spinnerService: NgxSpinnerService) {
  }
  ngOnInit() {
    this.isFromFooter = this.route.snapshot.paramMap.get('isFromFooter') == "true";

    if (this.isFromFooter) {
      var userId = sessionStorage.getItem('userId');
      if (this.userId) {
        this.spinnerService.show();
        this.dataService.getTermsandConditionsById(userId).subscribe((result: any) => {
          if (result) {
            this.termsAndConditionId = result; 
            this.getTermsandConditions();
          }
          this.spinnerService.hide();
        });
      }
      else {
        this.spinnerService.show();
        this.contactUsService.getTermsandConditions().subscribe((result: any) => {
          this.termsAndCondition = result;
          this.isTermsandConditionsAvailable = true;
          this.spinnerService.hide();
        });
      }

    }
    else {
      this.userId = this.route.snapshot.paramMap.get('userId');
      this.showWelcomePage = this.route.snapshot.paramMap.get('showWelcomePage') == 'true';
      this.isUserLoggedIn = this.route.snapshot.paramMap.get('isUserLoggedIn') == 'true';
      this.spinnerService.show();
      this.dataService.getTermsAndConditionIdByUserId(this.userId).subscribe((response) => {
        if (response) {
          this.spinnerService.hide();
          this.termsAndConditionId = response;
          this.getTermsandConditions();
        }
      });
    }
  }
  public getTermsandConditions()
  {
    this.spinnerService.show();
    this.dataService.getTermsandConditions(this.termsAndConditionId).subscribe((apiResponse: TermsandConditions) => {
      if (apiResponse) {
        this.termsAndCondition = apiResponse;
        this.spinnerService.hide();
      }
    });
  }
  onTermsCheckBoxChange(event: MatCheckboxChange): void {
    this.termCheck = event.checked;
    this.isTermCheckSubmit = false;
  }
  onClickToRedirectToHomePage() {
    this.isTermCheckSubmit = true;
    if (this.termCheck) {
      if(this.termsAndCondition.isContentUpdated || this.showWelcomePage){
        this.isUserLoggedIn=true;
        let updateUserAccount={
          userId:this.userId,
          termsAndConditionId:this.termsAndCondition.id,
          isUserLoggedIn: this.isUserLoggedIn
        };
        this.spinnerService.show();
        this.dataService.putRequestToUpdateTermsAndConditionId(updateUserAccount).
        subscribe((updateResponse:any) => {
          this.spinnerService.hide();
          if(updateResponse){
            this.router.navigate(['creditorhome']);
          }
        });

      }
      else{
        this.router.navigate(['creditorhome']);
      }
     
    }
    
  }

  onClickToCancel(){
    this.router.navigate(['']);
  }

}
